import type { Item } from '../../domain/inventory';

/**
 * The reconciler owns automation-originated attention flags. Its tag is part
 * of the server-side contract, so the UI deliberately classifies by the
 * attention reason rather than by the item writer.
 */
export const STATUS_RECONCILER_ATTENTION_PREFIX = '[status_reconciler] ';

export const attentionSourceValues = ['automation', 'manual'] as const;
export type AttentionSource = (typeof attentionSourceValues)[number];

export const attentionSourceLabels: Record<AttentionSource, string> = {
  automation: 'Auto',
  manual: 'Manual',
};

export function attentionSourceForItem(
  item: Pick<Item, 'needsAttention' | 'attentionReason'>,
): AttentionSource | undefined {
  if (!item.needsAttention) return undefined;
  return item.attentionReason?.startsWith(STATUS_RECONCILER_ATTENTION_PREFIX)
    ? 'automation'
    : 'manual';
}
